import './App.css';
import MovieApp from './components/MovieApp';

function App() {
  return (
    <MovieApp />
  );
}

export default App;
